module.exports = __webpack_public_path__ + "img/ic-ic-pro-default.e72b02df.svg";